import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, SUPPORTED_LANGS, DEFAULT_LANG } from "./translations";

const STORAGE_KEY = "ptr_lang";

const I18nContext = createContext({
    lang: DEFAULT_LANG,
    t: translations[DEFAULT_LANG],
    setLang: () => {},
});

const detectInitialLang = () => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
    } catch (_e) {
        /* ignore */
    }
    const nav = (window.navigator?.language || "").toLowerCase();
    if (nav.startsWith("fr")) return "fr";
    return DEFAULT_LANG;
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(detectInitialLang);

    useEffect(() => {
        if (typeof document !== "undefined") {
            document.documentElement.setAttribute("lang", lang);
        }
        try {
            window.localStorage.setItem(STORAGE_KEY, lang);
        } catch (_e) {
            /* ignore */
        }
    }, [lang]);

    const setLang = useCallback((next) => {
        if (SUPPORTED_LANGS.includes(next)) setLangState(next);
    }, []);

    const value = {
        lang,
        t: translations[lang],
        setLang,
        toggle: () => setLangState((l) => (l === "en" ? "fr" : "en")),
    };

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
